import { UiColors } from "../../../../config/ui/colors";

export const EVOLUTION_OF_ENERGY_CONSUMPTION_AND_ENERGY_PRICES_CHART_DATA_KEYS = [
	{
		name: "householdsEnergyConsumption",
		translation: "pages.pillar.pillar1.evolutionOfEnergyConsumptionAndEnergyPrices.blocks.chart.dataKeys.householdsEnergyConsumption",
		color: UiColors.charts.primary,
	},
	{
		name: "privateConsumption",
		translation: "pages.pillar.pillar1.evolutionOfEnergyConsumptionAndEnergyPrices.blocks.chart.dataKeys.privateConsumption",
		color: UiColors.charts.secondary,
	},
	{
		name: "averageEnergyPrices",
		translation: "pages.pillar.pillar1.evolutionOfEnergyConsumptionAndEnergyPrices.blocks.chart.dataKeys.averageEnergyPrices",
		color: UiColors.charts.tertiary,
	},
];